<template>
  <v-container fluid class="routeplan-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Route Plan</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>
          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Route Plan</p>
                        <v-select
                          class="mb-4"
                          :items=plantype
                          v-model="new_routeplan.plantype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the plan type">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                      <p class="text-h5">&nbsp;</p> 
                        <v-menu
                          ref="menu_plandate"
                          v-model="menu_plandate"
                          :close-on-content-click="false"
                          :return-value.sync="new_routeplan.plandate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="new_routeplan.plandate"
                              label="Plan Date"
                              v-bind="attrs"
                              v-bind:value="new_routeplan.plandate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please choose the plan date">
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_routeplan.plandate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_plandate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_plandate.save(new_routeplan.plandate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>                                  
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                              to="/routeplan/list"
                              replace
                              outlined
                              color="primary"
                          >
                            Cancel
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <v-data-table
                        hide-default-footer
                        :headers="header_items"
                        :items="data_items"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:item.repid="{ item }">
                          <div v-if="item.repid!=undefined" style="height: 100%; padding-top: 10px;">
                            <p class="two-line" style="margin-left: 0px;">
                              <v-avatar v-if="item.repid!=null && users.length>0" size="40">
                                <img v-bind:src="users.find(i=>i._id == item.repid)['userimage']" alt="">
                              </v-avatar>
                              <v-avatar
                                v-else
                                color="warning"
                                size="40">
                                <p class="two-line"><span class="white--text headline">{{ item.repid!=null && users.length>0 ? users.find(user=>i._id==item.repid)['username'][0].toUpperCase() : '' }}</span></p>
                              </v-avatar>
                            </p>
                          <p class="two-line"><span style="margin-left:0px; font-size: 9pt;">{{ item.repid!=null && users.length>0 ? users.find(i=>i._id==item.repid)['username'] : '' }} </span></p>
                          <p class="two-line"><span style="margin-left:0px; font-size: 9pt;">{{ item.locationid!=null && locations.length>0 ? locations.find(i=>i._id==item.locationid)['locationcode'] : '' }} </span></p>
                          </div>
                        </template>
                          <template v-slot:item._id="{ item }">
                            <div style="height: 100%; padding-top: 5px;">
                              <v-select
                                class="mb-4"
                                :items=[1,2,3,4,5,6,7,8,9,10,11,12]
                                v-model="item.daynum"
                                v-bind:error="errorindex == 0"
                                dense
                                placeholder="Day">
                              </v-select>
                            </div>
 
                          </template>
                          <template v-slot:item.routename="{ item }">
                            <div style="vertical-align: top; height: 100%; padding-top: 10px;">
                              <p class="two-line" style="font-size: 12pt;">{{ item.routename }}</p>
                              <p class="two-line" style="font-size: 13pt;">{{ getRouteItems(item) }}</p>
                              <div style="padding-top: 5px; padding-bottom: 5px;"></div>
                              <v-text-field
                                class="mb-4"
                                v-model="item.plannote"
                                dense
                                placeholder="Note or Instructions"
                                >
                              </v-text-field>
                            </div>
                          </template>
                          <template v-slot:item.routenum="{ item }">
                            <div style="height: 100%; padding-top: 15px;">{{ item.routenum }}</div>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="deleteRouteItem(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertRoutePlan()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import { formatStdDate } from '@/mixins/date';

export default {
  data () {
    return {
      step: 1,
      errorindex: undefined,
      error: undefined,
      haserror: false,
      menu_plandate: false,
      isFrom: null,
      header_items: [
        { text: '#', value: 'routenum', width: '5px'},
        { text: 'Sales Rep', value: 'repid', width: '12%'},
        { text: 'Day', value: '_id', width: '8%'},
        { text: 'Name', value: 'routename'},
        { text: 'Actions', value: 'actions', sortable: false, width: '5%' },
      ],
      data_bills: [],
      data_items: [],
      plantype: ['Route Plan'],
      new_routeplan: {},
    }
  },
  computed: {
    ...mapState('RoutePlan', ['routeplans', 'isReceiving']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Route', ['getRoutesAllRequest', 'getRouteDayRequest']),
    ...mapActions('RoutePlan', ['insertRoutePlanRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('User', ["getUsersRequest"]),
    checkError(){
    
      if(!this.new_routeplan.plantype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_routeplan.plandate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      this.step = 2;
      this.errorindex = -1;
      return true;
    },
    getRouteItems(route){
      let items = route.items.filter(i=>i.daynum==route.daynum).map(i=>{return `${i.itemnum}. ${i.itemname} ${i.itemdesc}`});
      let result = items.join(',  ')
      return result;
    },
    deleteRouteItem(item){
      let index = this.data_items.findIndex(i=>i._id==item._id);
      this.data_items.splice(index,1);
    },
    async insertRoutePlan() {
      if(this.data_items.length==0) return;
      let json = {plan: this.new_routeplan, items: this.data_items };
      await this.insertRoutePlanRequest(json);
      router.push('/routeplan/list');
    },
  },
  async created () {    
    this.new_routeplan.plandate = formatStdDate(new Date());
    let result = await this.getRoutesAllRequest();
    let route_day = await this.getRouteDayRequest();
    this.data_items = Object.assign([], result);
    
    this.data_items = this.data_items.map(i=>{return{...i, daynum: route_day.daynum}})
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
